<template>
	<AppPageHeader v-if="buttonDropdown" class="py-0">
		<template #left-side>
			<Row class="flex-align-center height-100">
				<AnemicButton @click="$router.back()" class="back-button mr-2" width="25" height="25" fab x-small>
					<AppIcon name="back" />
				</AnemicButton>
				<ButtonsDropdownIconsCard class="mr-2" :buttonDropdown="buttonDropdown" />
				<Col>
					<h3 class="reg mb-1">{{ title }}</h3>
					<Row class="flex-align-center">
						<ProjectChip :projectId="buttonDropdown.project" />
						<h5 class="desc">Button dropdown in {{ placementLocation }}</h5>
					</Row>
				</Col>
			</Row>
		</template>
	</AppPageHeader>
</template>

<script>
import ButtonsDropdownIconsCard from '@/components/Modules/ButtonsDropdownIconsCard.vue';
import { useButtonDropdown } from '@/store/modules/buttonDropdowns/getters';
import { getPlacement } from '@/store/modules/placements/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import PlacementService from '@/utils/placement-service';
import AppPageHeader from '@/views/AppLayout/AppPageHeader.vue';
import ProjectChip from '@/views/Flow/ProjectChip.vue';
export default {
	name: 'EditButtonsDropdownHeader',
	components: {
		ProjectChip,
		AppPageHeader,
		ButtonsDropdownIconsCard,
	},
	computed: {
		...mapGettersShorthand({ useButtonDropdown, getPlacement }),
		title() {
			return this.buttonDropdown.title;
		},
		placement() {
			return this.getPlacement(this.buttonDropdown.placement);
		},
		placementLocation() {
			return PlacementService.getFullItemName(this.placement);
		},
		buttonDropdown() {
			return this.useButtonDropdown(this.id);
		},
	},
	created() {
		this.id = this.$route.params.id;
	},
	data: () => ({
		id: null,
	}),
};
</script>

<style scoped lang="scss">
.desc {
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-weight: 300;
}
</style>
